const routes = {
    locations: "/locations",
    orders: "/orders",
    hints: "/hints",
    welcome: "/welcome",
    home: "/",
    bookLocationP2PPath: "/p2p/book",
    p2PItemRetrievalPath: "/recipient/orders",
    parcelItemRetrievalPath: "/parcel/item-retrieval",
    parcelItemPlacementPath: "/parcel/item-placement",
    temStorageNewBooking: "/temStorage/book",
    tempStorageStartUsing: "/tempStorage/startUsing",
    p2PSenderRetrievalPath: "/finishRental/:token",
    // p2PItemRetrievalPath: '/p2p/item-retrieval',
    bookLocationEquipmentRentalPath: "/equipmentRental/book",
    bookParcelDeliveryPath: "/parcelDelivery/book",
    bookLocationSUPPath: "/sup/book",
    bookLocationKeysPath: "/key-handover/book",
    keyHandoverLocationSelectionPath: "/key-handover/location-selection",
    keyHandoverPaymentModelPath: "/key-handover/payment-model",
    keyHandoverServiceSelectionPath: "/key-handover/service-selection",
    keyHandoverSchedulePath: "/key-handover/schedule",
    keyHandoverReturnSchedulePath: "/key-handover/return-schedule",
    keyHandoverHostDetailsPath: "/key-handover/host-details",
    keyHandoverGuestDetailsPath: "/key-handover/guest-details",
    keyHandoverSummaryPath: "/key-handover/summary",
    keyHandoverPaymentPath: "/key-handover/payment",
    keyHandoverSubscriptionChoicePath: "/key-handover/subscription-choice",
    // Flow 2: New subscription
    keyHandoverSubscriptionPlanSelectionPath: "/key-handover/subscription/plan-selection",
    keyHandoverSubscriptionEmailInputPath: "/key-handover/subscription/email-input",
    keyHandoverSubscriptionVerifyCodePath: "/key-handover/subscription/verify-code",
    keyHandoverSubscriptionHostDataPath: "/key-handover/subscription/host-data",
    keyHandoverSubscriptionSummaryPath: "/key-handover/subscription/summary",
    keyHandoverSubscriptionPaymentPath: "/key-handover/subscription/payment",
    keyHandoverSubscriptionSuccessPath: "/key-handover/subscription/success",
    // Flow 3: Existing subscription
    keyHandoverSubscriptionLoginPath: "/key-handover/subscription/login",
    keyHandoverSubscriptionVerifyPath: "/key-handover/subscription/verify",
    // § 312k: cancel or withdraw from any device (Infos → login → this page).
    // The agreement id lives in Redux, never in this URL.
    keyHandoverSubscriptionManagePath: "/key-handover/subscription/manage",

    // H-3a end-user account system (email + OTP login)
    accountPath: "/account",
    accountLoginPath: "/account/login",
    accountLoginVerifyPath: "/account/login/verify",
    // #2163 — member management by a customer organization's contact. The
    // organization id is in the path so a refresh or a deep link restores it,
    // never `data[0]`.
    accountOrganizationMembersPath: "/account/organization/:organizationId/members",
    // #3037 — the organization's booking plan (members read, owners cancel).
    accountOrganizationBookingsPath: "/account/organization/:organizationId/bookings",
    // Series booking for the organisation (series booking, step 11). Owners only.
    accountOrganizationSeriesPath: "/account/organization/:organizationId/series",
    // "Our hall times" (W2-1): members read, owners release a date.
    accountOrganizationHallTimesPath: "/account/organization/:organizationId/hall-times",

    keyRetrievalPath: "/order/key-retrieval",
    roomRentalPath: "/roomRental/book",
    venueReservationPath: "/venue/book",
    // A sports hall's own customer link, running the venue flow (PO, 2026-10-18).
    hallReservationPath: "/hall/book",
    // M3 (#3036): one room's week, to plan from and book into.
    roomWeekPath: "/rooms/:groupId/week",
    // #3075: the public plan of a category's rooms (?category=&objectId=), to embed in a website.
    publicPlanPath: "/plan",
    moreToComePath: "/coming-soon",
    voucherPath: "/voucher-purchase",
    // Postpay acceptance deep link from the offer email (#1702, spec §5.2).
    // Declared as a STATIC path so it is not swallowed by `orderDetailsPath`
    // below — React Router ranks a literal segment above `:orderId`, and the
    // route is registered before it as well.
    acceptOrderPath: "/orders/accept",
    orderDetailsPath: "/orders/:orderId",
    reportIssuePath: "/orders/:orderId/report-issue",
    hintsPath: "/hints",
    tipsPath: "/hints/page/tips",
    pricePath: "/hints/pricing",
    faqsPath: "/hints/page/faqs",
    termsOfServicePath: "/hints/page/termsOfService",
    dataProtectionPath: "/hints/page/dataProtection",
    imprintPath: "/hints/page/imprint",
    hintsPagePath: "/hints/page/:hintPage",
    retrieveBookingEmailPath: "/retrieveBookingEmail",
    consentGDPRPagePath: "/consent",
    privacyGDPRPath: "/consent/page/:privcayPage",
    stripePaymentReturnPath: "/payments/stripe/return",
    voucherStripePaymentReturnPath: "/vouchers/payment/stripe/return",
    noPaymentReturnPath: "/payments/no_payment/return",
    subscriptionPaymentReturnPath: "/payments/subscription/return",
    makeHintsPath: (component: string) => routes.hintsPagePath.replace(":hintPage", component),
    makeOrderDetailsUrl: (orderId: string) => routes.orderDetailsPath.replace(":orderId", orderId),
    makePrivacyGDPRPath: (component: string) =>
        routes.privacyGDPRPath.replace(":privcayPage", component),
    makeIssueReportsUrl: (orderId: string) =>
        routes.reportIssuePath.replace(":orderId", orderId),
};

export default routes;
